module.exports = __webpack_public_path__ + "static/media/review_2.145483e7.jpg";